import PropTypes from 'prop-types';
import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import { withRouter } from 'react-router';
import { TransitionGroup, CSSTransition } from 'react-transition-group';

import PageNav from './IntroNav';
import IntroText from './IntroText';
import Page1 from './Page1';
import Page2 from './Page2';
import Page3 from './Page3';
import Page4 from './Page4';
import Page5 from './Page5';
import Page6 from './Page6';


class IntroRouter extends React.Component {

  state = {
    animationDirection: "forwards",
    in: true,
    next: null,
    busy: false,
  }

  handleEnter = () => this.setState({ busy: false })
  handleExit = () => this.setState({ busy: true })

  handleExited = () => {
    this.props.history.push(this.state.next);
    this.setState({ in: true });
  }

  prevPage = (prevPage) => {
    if (this.state.busy) return;
    this.setState({ in: false, next: prevPage, animationDirection: "reverse" });
  }

  nextPage = (nextPage) => {
    if (this.state.busy) return;
    this.setState({ in: false, next: nextPage, animationDirection: "forwards" });
  }

  render() {
    const { match } = this.props;

    return (
      <TransitionGroup className="TransitionGroup" style={{ height: '100%' }}>
        <Switch>
          <Route
            exact path={match.url}
            render={() => <Redirect to={`${match.url}/1`} />}
          />

          <Route
            exact path={`${match.url}/1`}
            render={() =>
              <CSSTransition
                in={this.state.in}
                timeout={1000}
                key="page-1"
                classNames="page"
                onEntered={this.handleEnter}
                onExit={this.handleExit}
                onExited={this.handleExited}
              >
                <Page1
                  direction={this.state.animationDirection}
                  handleStartIntro={() => this.nextPage('2')}
                  handleSkipIntro={() => this.nextPage('/main')}
                  mainRef={this.props.mainRef}
                />
              </CSSTransition>
            }
          />

          <Route
            exact path={`${match.url}/2`}
            render={() =>
              <CSSTransition
                in={this.state.in}
                timeout={1000}
                key="page-2"
                classNames="page"
                onEntered={this.handleEnter}
                onExit={this.handleExit}
                onExited={this.handleExited}
              >
                <Page2 direction={this.state.animationDirection}>
                  <PageNav
                    prev={() => this.prevPage("1")}
                    next={() => this.nextPage("3")}
                  >
                    <IntroText page="page-2" articleRef={this.props.mainRef}/>
                  </PageNav>
                </Page2>
              </CSSTransition>
            }
          />

          <Route
            exact path={`${match.url}/3`}
            render={() =>
              <CSSTransition
                in={this.state.in}
                timeout={1000}
                key="page-3"
                classNames="page"
                onEntered={this.handleEnter}
                onExit={this.handleExit}
                onExited={this.handleExited}
              >
                <Page3 direction={this.state.animationDirection}>
                  <PageNav
                    prev={() => this.prevPage("2")}
                    next={() => this.nextPage("4")}
                  >
                    <IntroText page="page-3" articleRef={this.props.mainRef}/>
                  </PageNav>
                </Page3>
              </CSSTransition>
            }
          />

          <Route
            exact path={`${match.url}/4`}
            render={() =>
              <CSSTransition
                in={this.state.in}
                timeout={1000}
                key="page-4"
                classNames="page"
                onEntered={this.handleEnter}
                onExit={this.handleExit}
                onExited={this.handleExited}
              >
                <Page4 direction={this.state.animationDirection}>
                  <PageNav
                    prev={() => this.prevPage("3")}
                    next={() => this.nextPage("5")}
                  >
                    <IntroText page="page-4" articleRef={this.props.mainRef}/>
                  </PageNav>
                </Page4>
              </CSSTransition>
            }
          />

          <Route
            exact path={`${match.url}/5`}
            render={() =>
              <CSSTransition
                in={this.state.in}
                timeout={1000}
                key="page-5"
                classNames="page"
                onEntered={this.handleEnter}
                onExit={this.handleExit}
                onExited={this.handleExited}
              >
                <Page5 direction={this.state.animationDirection}>
                  <PageNav
                    prev={() => this.prevPage("4")}
                    next={() => this.nextPage("6")}
                  >
                    <IntroText page="page-5" articleRef={this.props.mainRef}/>
                  </PageNav>
                </Page5>
              </CSSTransition>
            }
          />

          <Route
            exact path={`${match.url}/6`}
            render={() =>
              <CSSTransition
                in={this.state.in}
                timeout={1000}
                key="page-6"
                classNames="page"
                onEntered={this.handleEnter}
                onExit={this.handleExit}
                onExited={this.handleExited}
              >
                <Page6 direction={this.state.animationDirection}>
                  <PageNav
                    prev={() => this.prevPage("5")}
                    last
                  >
                    <IntroText page="page-6" articleRef={this.props.mainRef}/>
                  </PageNav>
                </Page6>
              </CSSTransition>
            }
          />
        </Switch>
      </TransitionGroup>
    );
  }
}

IntroRouter.propTypes = {
  mainRef: PropTypes.func.isRequired,
  navRef: PropTypes.func.isRequired,
};

export default withRouter(IntroRouter);



// WEBPACK FOOTER //
// ./src/pages/intro/IntroRouter.js